import { Button } from 'antd';
import styled from 'styled-components';

export const DownloadProgressContainer = styled.div`
    display: flex;
    flex-direction: column;
    border: 1px solid
        ${(props) =>
            props.theme.theme === 'light'
                ? '#e4e9f0'
                : props.theme.colors.antdBorderSecondary};
    border-radius: 6px;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.04);
    width: 100%;
`;

export const DownloadProgressHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 16px 24px;
    justify-content: space-between;
    flex-wrap: wrap;
    border-bottom: 1px solid
        ${(props) =>
            props.theme.theme === 'light'
                ? '#e4e9f0'
                : props.theme.colors.antdBorderSecondary};
`;

export const DownloadHeaderInfo = styled.div`
    display: flex;
    gap: 10px;
    align-items: center;
`;

export const DownloadHeaderActions = styled.div`
    display: flex;
    gap: 8px;
    width: min-content;
`;

export const DownloadIconWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    background-color: ${({ theme }) =>
        theme.theme === 'light' ? '#ebf3ff' : 'rgba(75, 124, 243, 0.18)'};
    color: ${({ theme }) => theme.colors.accentColor};
    border-radius: 6px;
`;

export const DownloadTitleGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const DownloadTitle = styled.h1`
    font-size: 14px;
    font-weight: 700;
    color: ${(props) =>
        props.theme.theme === 'light' ? '#373d3f' : '#f5f7fa'} !important;
    margin: 0px;
`;

export const DownloadSubtitle = styled.h2`
    font-size: 12px;
    font-weight: 400;
    color: ${(props) =>
        props.theme.theme === 'light' ? '#6b7280' : '#f5f7fa'} !important;
    margin: 0px;
    display: inline-flex;
    align-items: center;
    gap: 4px;
`;

export const DownloadListContent = styled.div`
    display: flex;
    flex-direction: column;
    padding-bottom: 10px;
`;

export const ContractsItemDownloadContainer = styled.div`
    padding: 12px 24px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: center;
`;

export const ContractsDownloadContainer = styled.div`
    display: flex;
    align-items: center;
    display: flex;
    gap: 16px;
    align-items: center;
`;

export const ContractRadiusProgress = styled.div<{
    status: 'error' | 'processing' | 'pending' | 'completed';
}>`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background-color: ${({ theme }) =>
        theme.theme === 'dark' ? 'rgba(250, 173, 20, 0.18)' : '#fffbe6'};
    color: ${({ theme }) => (theme.theme === 'dark' ? '#ffd666' : '#faad14')};

    ${({ status, theme }) =>
        status === 'completed' &&
        `
        background-color: ${
            theme.theme === 'dark' ? 'rgba(32, 172, 84, 0.2)' : '#F6FFED'
        };
        color: ${theme.theme === 'dark' ? '#95DE64' : '#20AC54'};
    `}
    ${({ status, theme }) =>
        status === 'error' &&
        `
        background-color: ${
            theme.theme === 'dark' ? 'rgba(255, 77, 79, 0.18)' : '#FFF1F0'
        };
        color: ${theme.theme === 'dark' ? '#FF7875' : '#FF4D4F'};
    `}
`;

export const ContractsProgressLabels = styled.div`
    display: flex;
    flex-direction: column;
`;

export const ContractsProgressTitle = styled.h1`
    font-size: 13px;
    font-weight: 400;
    color: ${(props) =>
        props.theme.theme === 'light' ? '#373d3f' : '#f5f7fa'} !important;
    margin-bottom: 4px;
`;

export const ContractsInfoRequest = styled.div`
    display: flex;
    gap: 12px;
`;

export const ContractsRequestItem = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 11px;
    font-weight: 400;
    color: ${(props) =>
        props.theme.theme === 'light' ? '#6b7280' : '#f5f7fa'} !important;
    display: inline-flex;
    align-items: center;
`;

export const ContractsProgressActions = styled.div`
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    align-items: center;
`;

export const Badge = styled.div<{
    status?: 'completed' | 'pending' | 'processing' | 'error' | 'success';
}>`
    display: flex;
    align-items: center;
    padding: 0px 8px;
    height: 21px;
    font-size: 11px;
    font-weight: 700;
    border-radius: 20px;

    ${(props) =>
        (props.status === 'success' || props.status === 'completed') &&
        `
        background-color: ${
            props.theme.theme === 'dark' ? 'rgba(32, 172, 84, 0.2)' : '#F6FFED'
        };
        color: ${props.theme.theme === 'dark' ? '#95DE64' : '#3F9C14'};
    `}

    ${(props) =>
        props.status === 'error' &&
        `
        background-color: ${
            props.theme.theme === 'dark' ? 'rgba(255, 77, 79, 0.18)' : '#FFF1F0'
        };
        color: ${props.theme.theme === 'dark' ? '#FF7875' : '#FF4D4F'};
    `}

    ${(props) =>
        props.status === 'processing' &&
        `
          background-color: ${
              props.theme.theme === 'dark'
                  ? 'rgba(250, 173, 20, 0.18)'
                  : '#fffbe6'
          };
          color: ${props.theme.theme === 'dark' ? '#ffd666' : '#b37800'};
    `}
`;

export const ProgressText = styled.span`
    font-size: 12px;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.antdTextSecondary};
`;

export const DownloadListFooter = styled.div`
    display: flex;
    align-items: center;
    padding: 12px 24px;
    justify-content: space-between;
    flex-wrap: wrap;
    border-top: 1px solid
        ${(props) =>
            props.theme.theme === 'light'
                ? '#e4e9f0'
                : props.theme.colors.antdBorderSecondary};
`;

export const DownloadSummary = styled.span`
    font-size: 12px;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.antdTextSecondary};
    display: inline-flex;
    gap: 4px;
`;

export const DownloadCountHighlight = styled.span`
    font-size: 12px;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.antdText};
`;

export const ToggleListButton = styled(Button)`
    height: 34px;
    border: 1px solid ${({ theme }) => theme.colors.antdBorder};
    color: ${({ theme }) => theme.colors.antdText};
`;
